"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    id: _propTypes.string,
    onChange: _propTypes.func,
    label: _propTypes.string,
    description: _propTypes.string,
    icon: _propTypes.string,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    subheadline: _propTypes.string,
    subheadlineColor: _propTypes.PropTypes.oneOf(_constant.ARR_COLORS),
    accessibility: _propTypes.PropTypes.exact({
      headline: _propTypes.PropTypes.bool,
      subheadline: _propTypes.PropTypes.bool
    }),
    customProperties: _propTypes.PropTypes.exact({
      headline: _propTypes.PropTypes.object,
      subheadline: _propTypes.PropTypes.object
    }),
    limit: _propTypes.string,
    compPhotoType: _propTypes.string
  },
  DefaultProps: {
    id: _constant2.PHOTO_UPLOAD_DEFAULTS.ID,
    label: _constant2.PHOTO_UPLOAD_DEFAULTS.LABEL,
    icon: _constant2.PHOTO_UPLOAD_DEFAULTS.ICON,
    theme: _constant.DEFAULT_THEME,
    accessible: true
  }
};
exports.default = _default;